export enum ToolID {
  VIDEO_POPUP = 0,
  ON_DEMAND_HINT,
  RUBRIC_POPUP,
  PREK2_VIDEO_POPUP,
  PREK2_VERBAL_PROMPT,
  VERBAL_ON_DEMAND_PROMPT,
}
